module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page-team-profile__container c-page--container c-marg--before-footer u-relative u-pad-y-1"
  }, [_c('div', {
    staticClass: "u-align-center u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-team-logo-big__bg o-wrapper--valign u-inline-block u-align-center u-marg-t-xxl u-marg-b-xxl"
  }, [_c('app-img', {
    staticClass: "u-inline-block u-valign-middle",
    attrs: {
      "src": _vm.contentPage.logo,
      "width": "127",
      "alt": _vm.contentPage.name
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-b-xxxl u-align-center"
  }, [_c('abbr', {
    staticClass: "t-text--xl u-block u-color--gray-light u-hide@md",
    attrs: {
      "title": "contentPage.name"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.acronym)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-marg-x-auto u-marg-b-md u-flex u-flex-ai--center u-flex-jc--center"
  }, [_c('strong', {
    staticClass: "c-teams--name t-h u-bold u-uppercase t-text--xxl@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.name)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-team-profile__social-links-container u-marg-b-lg u-flex u-flex-fd--column@md u-flex-ai--center u-flex-jc--space-between u-pad-y-md"
  }, [_c('div', {
    staticClass: "u-w1of6 u-pad-y-xxs"
  }, [(_vm._getPreviousNextTeamFromID(_vm.teamIndex - 1)) ? _c('router-link', {
    staticClass: "c-team-profile__prev-team-container u-flex u-hide@md u-flex-jc--start u-cursor-pointer",
    attrs: {
      "to": _vm._getPreviousNextTeamFromID(_vm.teamIndex - 1)
    }
  }, [(_vm.teamIndex > 0) ? _c('div', {
    staticClass: "u-relative u-flex u-flex-jc--center u-flex-ai--center"
  }, [_c('svg', {
    staticClass: "c-team-profile__arrow--prev u-relative u-index--2",
    attrs: {
      "viewBox": "0 0 5.91 10.06",
      "width": "7",
      "height": "13",
      "fill": "#dc2730",
      "fill-opacity": "1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M.89,10.06,0,9.18l.09-.09L4.15,5,0,.89.89,0l5,5Z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-team-profile__prev-team u-absolute u-index--1 u-color--red u-uppercase t-text--xs t-text--bold"
  }, [_vm._v("Previous team")])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.contentPage.observeId !== false) ? _c('app-btn', {
    staticClass: "u-marg-r-sm u-valign-middle u-marg-r-0@md u-marg-b-xxs@md",
    on: {
      "click": function($event) {
        _vm.openModalRegister()
      }
    }
  }, [_c('span', {
    staticClass: "c-register-btn-icon__container u-inline-block"
  }, [_c('img', {
    staticClass: "c-register-btn-icon__img u-absolute u-pos-l u-pos-y-center",
    attrs: {
      "src": require("../../../assets/icon/icon-register--support.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "u-valign-middle",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomy.support)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-valign-middle u-bold"
  }, [_vm._v("(" + _vm._s(_vm.contentPage.observeCount) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-valign-middle  u-block@md"
  }, [(_vm.contentPage.social.facebook) ? _c('app-btn-social-link', {
    staticClass: "u-marg-x-xxxs u-valign-middle",
    attrs: {
      "url": _vm.contentPage.social.facebook,
      "type": "facebook"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentPage.social.twitter) ? _c('app-btn-social-link', {
    staticClass: "u-marg-x-xxxs u-valign-middle",
    attrs: {
      "url": _vm.contentPage.social.twitter,
      "type": "twitter"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentPage.social.youtube) ? _c('app-btn-social-link', {
    staticClass: "u-marg-x-xxxs u-valign-middle",
    attrs: {
      "url": _vm.contentPage.social.youtube,
      "type": "youtube"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentPage.social.link) ? _c('app-btn-social-link', {
    staticClass: "u-marg-x-xxxs u-valign-middle",
    attrs: {
      "url": _vm.contentPage.social.link,
      "type": "link"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "u-w1of6 u-pad-y-xxs"
  }, [(_vm._getPreviousNextTeamFromID(_vm.teamIndex + 1)) ? _c('router-link', {
    staticClass: "c-team-profile__next-team-container u-flex u-hide@md u-flex-jc--end u-flex-ai--center u-cursor-pointer",
    attrs: {
      "to": _vm._getPreviousNextTeamFromID(_vm.teamIndex + 1),
      "data-teamindex": _vm.teamIndex
    }
  }, [(_vm.teamIndex < _vm.contentGlobal.teamsAll.length - 1) ? _c('div', {
    staticClass: "u-relative u-flex u-flex-ai--center"
  }, [_c('span', {
    staticClass: "c-team-profile__next-team u-absolute u-index--1 u-color--red u-uppercase t-text--xs t-text--bold"
  }, [_vm._v("Next team")]), _vm._v(" "), _c('svg', {
    staticClass: "c-team-profile__arrow--next u-relative u-index--2",
    attrs: {
      "viewBox": "0 0 5.91 10.06",
      "width": "7",
      "height": "13",
      "fill": "#dc2730",
      "fill-opacity": "1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M.89,10.06,0,9.18l.09-.09L4.15,5,0,.89.89,0l5,5Z"
    }
  })])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "c-team-profile__social-links-container__bottom u-marg-t-md u-pad-y-md u-hide u-flex-jc--space-between u-flex-ai--center u-fit-w"
  }, [_c('div', {
    staticClass: "u-w1of2 u-pad-y-xxs"
  }, [(_vm._getPreviousNextTeamFromID(_vm.teamIndex - 1)) ? _c('router-link', {
    staticClass: "c-team-profile__prev-team-container u-flex u-flex-jc--start u-cursor-pointer",
    attrs: {
      "to": _vm._getPreviousNextTeamFromID(_vm.teamIndex - 1)
    }
  }, [(_vm.teamIndex > 0) ? _c('div', {
    staticClass: "u-relative u-flex u-flex-jc--center u-flex-ai--center"
  }, [_c('svg', {
    staticClass: "c-team-profile__arrow--prev u-relative u-index--2",
    attrs: {
      "viewBox": "0 0 5.91 10.06",
      "width": "7",
      "height": "13",
      "fill": "#dc2730",
      "fill-opacity": "1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M.89,10.06,0,9.18l.09-.09L4.15,5,0,.89.89,0l5,5Z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-team-profile__prev-team u-absolute u-index--1 u-color--red u-uppercase t-text--xs t-text--bold"
  }, [_vm._v("Previous team")])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "u-w1of2 u-pad-y-xxs"
  }, [(_vm._getPreviousNextTeamFromID(_vm.teamIndex + 1)) ? _c('router-link', {
    staticClass: "c-team-profile__next-team-container u-flex u-flex-jc--end u-flex-ai--center u-cursor-pointer",
    attrs: {
      "to": _vm._getPreviousNextTeamFromID(_vm.teamIndex + 1)
    }
  }, [(_vm.teamIndex < _vm.contentGlobal.teamsAll.length - 1) ? _c('div', {
    staticClass: "u-relative u-flex u-flex-ai--center"
  }, [_c('span', {
    staticClass: "c-team-profile__next-team u-absolute u-index--1 u-color--red u-uppercase t-text--xs t-text--bold"
  }, [_vm._v("Next team")]), _vm._v(" "), _c('svg', {
    staticClass: "c-team-profile__arrow--next u-relative u-index--2",
    attrs: {
      "viewBox": "0 0 5.91 10.06",
      "width": "7",
      "height": "13",
      "fill": "#dc2730",
      "fill-opacity": "1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M.89,10.06,0,9.18l.09-.09L4.15,5,0,.89.89,0l5,5Z"
    }
  })])]) : _vm._e()]) : _vm._e()], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "t-text--md t-lspacing--sm u-color--gray-blue u-line-height--lg u-align-center u-marg-x-auto u-w7of14@xl",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.description)
    }
  })]), _vm._v(" "), (_vm.teamGames.length > 0) ? _c('div', {
    staticClass: "u-relative u-fit-w u-marg-b-xxl"
  }, [_c('section', {
    staticClass: "u-fit-w u-flex--x u-block@md u-flex--center u-align-center"
  }, _vm._l((_vm.teamGames), function(game, index) {
    return _c('app-btn-filter', {
      key: index,
      staticClass: "u-marg-x-xxs u-uppercase u-flex--x u-block@md u-marg-x-auto@md u-marg-b-xs@md",
      class: {
        'is-selected': parseInt(game.id, 10) === _vm.currentGameId
      },
      on: {
        "click": function($event) {
          _vm.filterVideoGame(parseInt(game.id, 10))
        }
      }
    }, [_c('img', {
      staticClass: "is-img",
      attrs: {
        "src": game.logo_light,
        "alt": game.name,
        "title": game.name
      }
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.teamGames.length > 0) ? _c('div', {
    staticClass: "u-align-center u-vacuum u-marg-l-w1of6 u-w2of3 u-marg-b-xxxl u-marg-l-0@md u-fit@md"
  }, [_c('div', {
    staticClass: "u-inline-block u-valign-top u-w1of3"
  }, [_c('strong', {
    staticClass: "t-text--sm u-block u-marg-b-sm u-bold u-uppercase t-lspacing--md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.scores.win)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-team-score u-block u-color--gray-blue",
    domProps: {
      "innerHTML": _vm._s(_vm.getScoreById(_vm.currentGameId).win)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-valign-top u-w1of3"
  }, [_c('strong', {
    staticClass: "t-text--sm u-block u-marg-b-sm u-bold u-uppercase t-lspacing--md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.scores.rank)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-team-rank u-inline-block o-wrapper--valign"
  }, [_c('span', {
    staticClass: "t-text--xxxl u-marg-t-xxs u-inline-block u-valign-middle u-color--red-pure",
    domProps: {
      "innerHTML": _vm._s(_vm.getScoreById(_vm.currentGameId).rank)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-valign-top u-w1of3"
  }, [_c('strong', {
    staticClass: "t-text--sm u-block u-marg-b-sm u-bold u-uppercase t-lspacing--md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.scores.lose)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-team-score u-block u-color--gray-blue",
    domProps: {
      "innerHTML": _vm._s(_vm.getScoreById(_vm.currentGameId).lose)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.players.length > 0) ? _c('strong', {
    staticClass: "u-block u-align-center u-color--red-pure u-bold t-text--xxxl t-lspacing--sm u-uppercase u-marg-b-lg",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.players.title.replace(':game', _vm.getVideoGameFromID(_vm.currentGameId).name))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.players.length > 0) ? _c('table', {
    staticClass: "u-fit-w u-align-left u-marg-b-xxxl u-hide@md"
  }, [_c('tr', {
    staticClass: "c-team-profile__table-head u-color--gray-dark u-uppercase"
  }, _vm._l((_vm.currentHeadsOfTable), function(head, index) {
    return _c('th', {
      class: [index === 0 ? 'u-pad-l-xs' : '', 'u-align-' + head.align],
      domProps: {
        "innerHTML": _vm._s(head.label)
      }
    })
  })), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.players), function(player, i) {
    return [_c('tr', {
      staticClass: "c-team-profile__line",
      class: {
        'c-team-profile__bg': !(i % 2)
      }
    }, [_c('td', [_c('app-hexagon', {
      attrs: {
        "src": player.img || '/static/player/player-logo-default.png',
        "side": 54
      },
      on: {
        "load": _vm._onResize
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "u-inline-block u-marg-l-xxxs"
    }, [_c('span', {
      staticClass: "t-text--sm t-lspacing--sm u-color--gray-text u-align-center u-block u-marg-b-xxxs",
      domProps: {
        "innerHTML": _vm._s(player.country.toUpperCase())
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": '/static/team/icon-flag-' + player.country.toLowerCase() + '.png',
        "alt": "",
        "width": "55",
        "height": "35"
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "c-player-row u-relative"
    }, [_c('div', {
      staticClass: "c-player-row__name u-marg-b-xxxs"
    }, [_c('span', {
      staticClass: "t-text--xxxl t-lspacing--sm u-line-height--sm u-block u-bold u-uppercase",
      domProps: {
        "innerHTML": _vm._s(player.nickname)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "t-text--sm t-lspacing--md u-uppercase"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(player.name)
      }
    }), _vm._v(" "), (_vm.getYears(player.birthdate) > 0) ? [_vm._v("\n                                     - "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getYears(player.birthdate))
      }
    })] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "u-align-left"
    }, [_c('router-link', {
      staticClass: "c-player-row__link t-text--sm u-color--red-pure u-uppercase u-bold u-relative u-click-area--xxs",
      attrs: {
        "to": _vm.$root.getPageURLFromID('player', {
          slug: player.slug
        })
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.contentPage.taxonomy.buttonPlayer)
      }
    }), _vm._v(" "), _c('svg', {
      staticClass: "c-player-row__link__arrow",
      attrs: {
        "viewBox": "0 0 5.91 10.06",
        "width": "6",
        "height": "11",
        "fill": "#dc2730",
        "fill-opacity": "1"
      }
    }, [_c('path', {
      staticClass: "cls-1",
      attrs: {
        "d": "M.89,10.06,0,9.18l.09-.09L4.15,5,0,.89.89,0l5,5Z"
      }
    })])])], 1)]), _vm._v(" "), _vm._l((player.stats), function(stat) {
      return _c('td', {
        staticClass: "t-text--xl t-lspacing--sm u-color--gray-light u-align-center",
        domProps: {
          "innerHTML": _vm._s(stat)
        }
      })
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "c-team-profile__hr",
      attrs: {
        "colspan": "5"
      }
    })])]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.players.length > 0) ? _c('div', {
    staticClass: "u-hide u-fit-w u-marg-b-xxxl u-marg-t-xxl u-flex--y@md"
  }, [_c('div', {
    staticClass: "c-team-profile__hr"
  }), _vm._v(" "), _vm._l((_vm.players), function(player, i) {
    return _c('div', {
      staticClass: "u-pad-y-1",
      class: {
        'c-team-profile__bg': !(i % 2)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goto(_vm.$root.getPageURLFromID('player', {
            slug: player.slug
          }))
        }
      }
    }, [_c('div', {
      staticClass: "u-flex--x u-marg-t-md"
    }, [_c('div', {
      staticClass: "u-w1of3"
    }, [_c('app-hexagon', {
      attrs: {
        "src": player.img || '/static/player/player-logo-default.png',
        "side": 44
      },
      on: {
        "load": _vm._onResize
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "c-player-row o-wrapper--valign u-w2of3"
    }, [_c('p', {
      staticClass: "c-player-row__name u-valign-middle u-inline-block u-fit-w u-marg-b-xxxs"
    }, [_c('span', {
      staticClass: "t-text--xxxl t-lspacing--sm u-line-height--sm u-block u-bold u-uppercase u-break-word",
      domProps: {
        "innerHTML": _vm._s(player.nickname)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "t-text--sm t-lspacing--md u-uppercase u-break-word"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(player.name)
      }
    }), _vm._v(" "), (_vm.getYears(player.birthdate) > 0) ? [_vm._v("\n                                     - "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getYears(player.birthdate))
      }
    })] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "u-align-left"
    }, [_c('router-link', {
      staticClass: "t-text--sm u-color--red-pure u-uppercase u-bold u-relative u-click-area--xxs",
      attrs: {
        "to": _vm.$root.getPageURLFromID('player', {
          slug: player.slug
        })
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.contentPage.taxonomy.buttonPlayer)
      }
    }), _vm._v(" "), _c('app-arrow-link')], 1)], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "u-marg-b-md u-block u-vacuum"
    }, [_c('div', {
      staticClass: "u-w1of3 u-inline-block u-marg-t-xs"
    }, [_c('span', {
      staticClass: "u-inline-block u-marg-l-xxs"
    }, [_c('span', {
      staticClass: "t-text--sm t-lspacing--sm u-color--gray-text u-align-center u-block u-marg-b-xxxs",
      domProps: {
        "innerHTML": _vm._s(player.country.toUpperCase())
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": '/static/team/icon-flag-' + player.country.toLowerCase() + '.png',
        "alt": "Flag",
        "width": "55",
        "height": "35"
      }
    })])]), _vm._v(" "), _vm._l((player.stats), function(stat, index) {
      return _c('div', {
        staticClass: "u-w1of3 u-inline-block u-valign-top u-marg-t-xs"
      }, [_c('div', {
        staticClass: "u-inline-block u-w1of2"
      }, [_c('span', {
        staticClass: "t-text--xl t-lspacing--sm u-color--gray-light",
        domProps: {
          "innerHTML": _vm._s(stat)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "u-inline-block u-w1of2"
      })])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "c-team-profile__hr"
    })])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.players.length === 0) ? _c('div', {
    staticClass: "u-flex u-flex-ai--center u-flex-jc--center",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomy.noPlayersGame)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lasts.length > 0) ? [_c('strong', {
    staticClass: "u-block u-align-center u-color--red-pure u-bold t-text--xxxl t-lspacing--sm u-uppercase u-marg-t-xxxl u-marg-b-xl",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.prevMatches.title.replace(':num', _vm.lasts.length))
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "u-marg-t-xxl u-fit-w o-list--none"
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.lasts), function(match, i) {
    return [_c('app-matches-table-tr', {
      key: match.id,
      class: {
        'c-team-profile__bg': (i % 2) === 1
      },
      attrs: {
        "match": match,
        "contentGlobal": _vm.contentGlobal,
        "contentPage": _vm.contentPage
      }
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "c-player__bg-line u-height-1",
      attrs: {
        "colspan": "3"
      }
    })])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.nexts.length > 0) ? [_c('strong', {
    staticClass: "u-block u-align-center u-color--red-pure u-bold t-text--xxxl t-lspacing--sm u-uppercase u-marg-t-xxxl u-marg-b-xl",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.nextMatches.title.replace(':num', _vm.nexts.length))
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "u-marg-t-xxl u-fit-w o-list--none"
  }, [_c('tbody', [_vm._m(2), _vm._v(" "), _vm._l((_vm.nexts), function(match, i) {
    return [_c('app-matches-table-tr', {
      key: match.id,
      class: {
        'c-team-profile__bg': (i % 2) === 1
      },
      attrs: {
        "match": match,
        "contentGlobal": _vm.contentGlobal,
        "contentPage": _vm.contentPage
      }
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "c-player__bg-line u-height-1",
      attrs: {
        "colspan": "3"
      }
    })])]
  })], 2)])] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "c-team-profile__hr",
    attrs: {
      "colspan": "5"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "c-player__bg-line u-height-1",
    attrs: {
      "colspan": "3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "c-player__bg-line u-height-1",
    attrs: {
      "colspan": "3"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08749b34"}!./src/scripts/components/page-team-profile/template.html
// module id = 882
// module chunks = 0